// extracted by mini-css-extract-plugin
export var label = "_h1-2";
export var slideContainer = "_h1-0";
export var slider = "_h1-1";